import { interWbSession } from '@interco/inter-webview-bridge'

import type { FeedbackStepConfig, QuestionStepConfig } from './data'

const basePayload = {
  screen: 'cedulas-fakedoor',
  product: 'Cedulas',
  teste: 'Fakedoor',
}

export const trackSurveyStart = (question: QuestionStepConfig) => {
  interWbSession.requestAnalytics('CEDULAS_FAKEDOOR_ACESSO', {
    ...basePayload,
    content_action: 'Dado Carregado',
    title: question.title,
    step: question.stepNumber.toString(),
  })
}

export const trackContinue = (question: QuestionStepConfig, selectedIds: string[]) => {
  if (question.stepNumber === 1) {
    const [first, second, third, fourth, fifth] = question.options

    const answers = question.options
      .filter((o) => selectedIds.includes(o.id))
      .map((o) => o.analyticsValue ?? o.label)
      .join(' | ')

    interWbSession.requestAnalytics('CEDULAS_FAKEDOOR_FLUXO', {
      ...basePayload,
      content_action: 'Toque',
      ref_type: 'Botão',
      content_name: 'Continuar',
      title: question.title,
      first_answer: first.analyticsValue ?? first.label,
      second_answer: second.analyticsValue ?? second.label,
      third_answer: third.analyticsValue ?? third.label,
      fourth_answer: fourth.analyticsValue ?? fourth.label,
      fifth_answer: fifth.analyticsValue ?? fifth.label,
      answers,
      step: '1',
    })
    return
  }

  const selected = question.options.find((o) => selectedIds.includes(o.id))
  if (!selected) {
    return
  }

  interWbSession.requestAnalytics('CEDULAS_FAKEDOOR_FLUXO', {
    ...basePayload,
    content_action: 'Toque',
    ref_type: 'Botão',
    content_name: 'Continuar',
    title: question.title,
    answer: selected.analyticsValue ?? selected.label,
    step: question.stepNumber.toString(),
  })
}

export const trackFeedbackLoad = (feedback: FeedbackStepConfig) => {
  if (feedback.isSuccess) {
    interWbSession.requestAnalytics('CEDULAS_FAKEDOOR_SUCESSO', {
      ...basePayload,
      content_action: 'Dado Carregado',
      title: feedback.title,
      content_description: feedback.description,
      step: feedback.stepNumber.toString(),
    })
    return
  }

  interWbSession.requestAnalytics('CEDULAS_FAKEDOOR_ERRO', {
    ...basePayload,
    content_action: 'Dado Carregado',
    title: feedback.title,
    description: feedback.description,
  })
}

export const trackHeaderBack = ({ step }: { step: number }) => {
  interWbSession.requestAnalytics('HEADER', {
    ...basePayload,
    content_action: 'Toque',
    action_id: 'back',
    step: step.toString(),
  })
}

export const trackBannerClick = ({ step, contentName }: { step: number; contentName: string }) => {
  interWbSession.requestAnalytics('CEDULAS_FAKEDOOR_FLUXO', {
    ...basePayload,
    content_action: 'Toque',
    ref_type: 'Banner',
    content_name: contentName,
    step: step.toString(),
  })
}

export const trackGoBackHome = ({ step }: { step: number }) => {
  interWbSession.requestAnalytics('CEDULAS_FAKEDOOR_FLUXO', {
    ...basePayload,
    content_action: 'Toque',
    action_id: 'home',
    step: step.toString(),
  })
}

export const trackFeedbackButtonClick = ({ step }: { step: number }) => {
  interWbSession.requestAnalytics('CEDULAS_FAKEDOOR_FLUXO', {
    ...basePayload,
    content_action: 'Toque',
    ref_type: 'Botão',
    content_name: 'Voltar pra Home',
    step: step.toString(),
  })
}
